"use client"

import { generateResponsiveCSS } from "@/(admin)/modules/ui-builder/config/lib/helper"
import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import type { ComponentConfig } from "@measured/puck"
import { useParams } from "next/navigation"
import { useMemo, useState } from "react"
import { twMerge } from "tailwind-merge"
import { BecomeTDFCustomerContent } from "./components/BecomeTDFCustomerContent"
import type { BecomeTDFCustomerProps } from "./types"

export const RenderConfig: ComponentConfig<BecomeTDFCustomerProps> = {
  render: ({
    className,
    styles,
    responsiveType,
    id: componentId,
    ...props
  }: BecomeTDFCustomerProps & { id?: string }) => {
    const params = useParams()
    const storeLocale = useUIBuilderLocaleStore(state => state.locale)
    const locale = (params?.locale as string) || storeLocale || "vi"
    const id = useMemo(
      () => componentId || `become-tdf-customer-${Math.random().toString(36).substr(2, 9)}`,
      [componentId],
    )
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType || "mobileFirst")
    const [submitted, setSubmitted] = useState(false)
    const [submittedEmail, setSubmittedEmail] = useState<string | undefined>(props.registrationEmail)

    const handleSubmitted = (email?: string) => {
      setSubmittedEmail(email || props.registrationEmail)
      setSubmitted(true)
    }

    return (
      <>
        {responsiveCSS}
        <BecomeTDFCustomerContent
          {...props}
          id={id}
          className={twMerge(id, className)}
          submitted={submitted}
          submittedEmail={submittedEmail}
          onSubmitted={handleSubmitted}
          locale={locale}
        />
      </>
    )
  },
}
